import { Group, Layout, Page, Tree } from "@/comn/components";
import { useNavigate, useParams } from "react-router-dom";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useModal, useResource, useToast, usePage } from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { BASE, URLS, APIS, SF_CNTY_CD_INFO } from "@/tra/tancis/ptli/comnmdle/cntycd/services/PtliCntyCdService";

/*
 * Country Code Modification
 * !== 지역 코드 수정 ==!
 */
export const PTLI0414003S = () => {
    useResource({
        defaultSchema: [{ area: "cntyCd" }, { area: "comnCd", comnCd: "COM0033" }],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { cntyCd } = useParams();
    const modal = useModal();
    const toast = useToast();

    const form = {
        cntyCdInfo: useForm({
            defaultSchema: SF_CNTY_CD_INFO,
        }),
    };

    const fetch = {
        getCntyCdInfo: useFetch({
            api: () => APIS.getCntyCdInfo(cntyCd),
            onSuccess: (data: any) => {
                // 데이터가 없을 경우
                if (!data.cntyCdInfo.content) {
                    modal.openModal({ content: "msg.com.00034" }); // No data found. !== 해당 데이터가 없습니다. ==!

                    navigate(`${URLS.ptli0414001q}?menuId=${menuId}`);
                    return;
                }
                form.cntyCdInfo.setValues(data.cntyCdInfo.content);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
        updateCntyCdInfo: useFetch({
            api: (info: any) => APIS.updateCntyCdInfo(info),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00059" }); // Successfully updated. !== 정상적으로 수정되었습니다.==!
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00022" }), // Failed to update. !== 수정이 실패하였습니다.==!
        }),
        deleteCntyCdInfo: useFetch({
            api: (info: any) => APIS.deleteCntyCdInfo(info),
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00060" }); // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                navigate(`${URLS.ptli0414001q}?menuId=${menuId}`);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00023" }), // Failed to remove. !== 삭제가 실패하였습니다. ==!
        }),
    };

    const handler = {
        onListBtnClick: () => navigate(`${URLS.ptli0414001q}?menuId=${menuId}`),
        onUpdateBtnClick: form.cntyCdInfo.handleSubmit(
            () => {
                modal.openModal({
                    content: "msg.com.00050", // Confirm update? !== 수정하시겠습니까? ==!
                    onConfirm: () => fetch.updateCntyCdInfo.fetch(form.cntyCdInfo.getValues()),
                });
            },
            () => toast.showToast({ type: "warning", content: "msg.00002" }), // Data is invalid, !== 데이터가 유효하지않습니다. ==!
        ),
        onDeleteBtnClick: () => {
            modal.openModal({
                content: "msg.com.00049", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => fetch.deleteCntyCdInfo.fetch(form.cntyCdInfo.getValue("cntyCd")),
            });
        },
    };

    useEffect(() => {
        fetch.getCntyCdInfo.fetch();
        form.cntyCdInfo.setSchema("cntyCd", { edit: false });
        form.cntyCdInfo.setSchema("cntyCd", { edit: false });
        form.cntyCdInfo.setSchema("cntyTpCd", { edit: false });
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.cntyCdInfo.schema.cntyCd} />
                            <Group.Control {...form.cntyCdInfo.schema.dgt3CntyCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cntyCdInfo.schema.dgt3NumCntyCd} />
                            <Group.Control {...form.cntyCdInfo.schema.cntyEngAbrtNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cntyCdInfo.schema.cntyNmEn} />
                            <Group.Control {...form.cntyCdInfo.schema.cntyNmKo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cntyCdInfo.schema.cntyNmTz} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"edit"} onClick={handler.onUpdateBtnClick} />
                    <Layout.Button role={"delete"} onClick={handler.onDeleteBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
